import React, { useEffect, useState } from "react";
import Table from "./Table";
import { getData } from "./getData";
import { Link } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const Categories = () => {
	const dispatch = useDispatch();
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(false);
	const categoryType = window.location.pathname?.split("/")?.at(-1);

	useEffect(() => {
		init();
		dispatch(
			updateMeta({
				title: `التصنيفات ${categoryType === "sub" ? "الفرعية" : "الاساسية"}`,
				breadcrumb: `التصنيفات ${
					categoryType === "sub" ? "الفرعية" : "الاساسية"
				}`,
				button: {
					show: true,
					text: `اضافة تصنيف ${categoryType === "sub" ? "فرعي" : "اساسي"}`,
					link: `/categories/${categoryType}-add`,
				},
			})
		);
	}, []);

	const init = async () => {
		await getData({
			setData: data => {
				let sections = data?.data?.page?.sections;

				if (categoryType === "sub")
					sections = sections.filter(e => e?.category);
				else sections = sections.filter(e => !e?.category);
				setCategories(sections);
			},
			setLoading,
			url: `/pages/categories`,
		});
	};

	return (
		<div className="categories-wrap">
			{/* <Link to={`/categories/${categoryType}-add`}>
				اضافة تصنيف {categoryType === "sub" ? "فرعي" : "اساسي"}
			</Link> */}
			<Table data={categories} loading={loading} categoryType={categoryType} />
		</div>
	);
};

export default Categories;
